import { useEffect } from "react";
import { useLocation } from 'react-router-dom';



export const parseFrenchDate = (dateString) => {
  if (!dateString || typeof dateString !== 'string') return new Date(NaN);
  const [day, month, year] = dateString.split('/').map(Number);
  return new Date(year, month - 1, day);
};

// La FFTT renvoie `dateprevue` (programmée) et `datereelle` (jouée, parfois vide).
// Pour « les prochains matchs » on veut la date programmée en priorité.
export const matchDate = (match) => match?.dateprevue || match?.datereelle || '';

export const ScrollToAnchor = () => {
  const location = useLocation();

  useEffect(() => {
    const { hash } = location;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
};

